import { render, staticRenderFns } from "./SocialShareButton.vue?vue&type=template&id=78f3f1d1&scoped=true&"
import script from "./SocialShareButton.vue?vue&type=script&lang=js&"
export * from "./SocialShareButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f3f1d1",
  null
  
)

export default component.exports